__turbopack_context__.v({
  "blocksBackgroundColor": "PackeryGrid-module-scss-module__sGR2Vq__blocksBackgroundColor",
  "blocksFontColor": "PackeryGrid-module-scss-module__sGR2Vq__blocksFontColor",
  "packery": "PackeryGrid-module-scss-module__sGR2Vq__packery",
  "secondaryNavBackgroundColor": "PackeryGrid-module-scss-module__sGR2Vq__secondaryNavBackgroundColor",
  "themeBackgroundColor": "PackeryGrid-module-scss-module__sGR2Vq__themeBackgroundColor",
  "themeFontColor": "PackeryGrid-module-scss-module__sGR2Vq__themeFontColor",
});
